<div class="color-light font-14"
     [class]="{ 'menu__parent--hide': !menu.showDropdownMenu,
        'cursor-pointer': parameters.selectedModule.moduleStatus && parameters.selectedModule.controllerStatus }">

    <div class="submenu bg-submenu"
         [class]="{ 'submenu--hide': menu.showDropdownMenu }"
         [style]="{ 'height': views.submenuWindowHeight }"
         *ngIf="!menu.showInputField">
        <div class="submenu__search border-dark color-light">
            <img class="submenu__search-img"
                 ngSrc="/assets/img/icons/search.svg"
                 width="20" height="20"
                 alt="" />
            <input class="submenu__search-input color-light"
                   name="searchText"
                   (input)="menu.searchText(menu.search.txt, getMainMenu())"
                   [(ngModel)]="menu.search.txt"
                   placeholder="{{subtitle(1134)}}"
                   autocomplete="new-password">
            <img class="submenu__search-img cursor-pointer"
                 ngSrc="/assets/img/icons/clear-button.svg"
                 alt="{{subtitle(1099)}}"
                 *ngIf="menu.search.txt.length > 0"
                 (click)="menu.searchText('', getMainMenu())"
                    width="20" height="20" />
        </div>

        <ul class="submenu__list" data-testid="submenu">
            <li class="submenu__list-item"
                (click)="menu.goBack(menu.submenu[0])">
                <div class="submenu__item"
                     [ngSwitch]="(menu.submenu[0] !== undefined && menu.submenu[0]['parentId'] == 0)
                        || menu.search.txt.length > 0">
                    <img class="submenu__item-img"
                         priority="true"
                         ngSrc="/assets/img/icons/back.svg"
                         width="50" height="50"
                         alt="" />
                    <p class="submenu__item-name"
                       *ngSwitchCase="false">
                       {{subtitle(1744)}}
                    </p>
                    <p class="submenu__item-name"
                       *ngSwitchCase="true">
                       {{subtitle(915)}}
                    </p>
                </div>
            </li>

            <li class="submenu__list-item">
                <div class="submenu__item"
                     [class]="{ 'submenu__item': menu.submenu.length === 0,
                        'submenu__item--hide': menu.submenu.length !== 0 }">
                    <p class="submenu__item-empty">
                       {{ subtitle(1623)}}
                    </p>
                </div>
            </li>

            <li class="submenu__list-item"
                *ngFor="let val of menu.submenu.length ? menu.submenu : []"
                [class]="{ 'breadcrumbs-border': menu.search.txt.length > 1 && menu.smallBreadcrumbs }">
                <div class="submenu__item"
                     (mouseenter)="getBreadcrumbs(val, views.submenuWindowWidth)"
                     (click)="menu.getMenuChild(val, views.submenuWindowWidth)"
                     (mouseleave)="getBreadcrumbs(0)">
                    <div class='submenu__breadcrumbs-search'
                         *ngIf="menu.search.txt.length > 1">
                        <ng-container *ngFor="let elem of getBreadcrumbs(val); let lastIndex = last;">
                            <p class='submenu__breadcrumbs-search-item'
                               *ngIf="!lastIndex">
                                <span>{{ subtitle(elem.txtId) }}</span>
                                <span *ngIf="!(val.params.daySubtitles === 1)">
                                    {{setDay(elem.params.dayId)}}
                                </span>
                            </p>
                        </ng-container>
                    </div>
                    <img class="submenu__item-img"
                         ngSrc="{{setIcon(val['iconId'])}}"
                         width="50" height="50" alt="" />
                    <p class="submenu__item-name">
                        {{subtitle(val['txtId'])}}
                    </p>
                    <span class="submenu__item-week-name"
                        *ngIf="!(val.params.daySubtitles === 1)">
                        {{setDay(val['params']['dayId'])}}
                    </span>
                    <img class="submenu__item-img--next submenu__item-img"
                         *ngIf="val.type === 0 && !val.params.password"
                         ngSrc="/assets/img/icons/submenu.svg"
                         width="50" height="50" alt="" />
                    <img class="submenu__item-img--next submenu__item-img"
                         *ngIf="val.params?.password === 'password' || val.password === 'validPass'"
                         ngSrc="/assets/img/icons/password.svg"
                         width="50" height="50" alt="" />
                </div>
                <img class="submenu__item-wiki"
                     *ngIf="getWiki(val)"
                     ngSrc="/assets/img/icons/question.svg"
                     width="50" height="50" alt=""
                     data-testid="wiki-icon"
                     (click)="menu.showWiki(val)">
            </li>
        </ul>
    </div>

    <div class="breadcrumbs bg-submenu top-0"
         [class]="{ 'breadcrumbs--hide': menu.showDropdownMenu }"
         *ngIf="!menu.showInputField"
         [ngStyle]="{ left: '0', width: views.submenuWindowWidth - 470 + 'px'}">
        <ul class="breadcrumbs__list border-dark"
            *ngIf="subtitle(menu.breadcrumbFirst.txtId)">
            <li class="breadcrumbs__item">
                <span class="breadcrumbs__item-name">
                    {{subtitle(menu.breadcrumbFirst.txtId)}}
                </span>
            </li>
            <ng-container *ngFor="let item of menu.allBreadcrumbs">
                <li class="breadcrumbs__item"
                    *ngIf="!menu.smallBreadcrumbs || menu.search.txt.length === 0">
                    <span class="breadcrumbs__item-name">
                        {{subtitle(item.txtId)}}
                    </span>
                    <span *ngIf="!(item.params.daySubtitles === 1)">
                        {{setDay(item.params.dayId)}}
                    </span>
                </li>
            </ng-container>
        </ul>
    </div>

    @if (!menu.showInputField) {
        <div class="wiki-info-wrapper" [ngClass]="wikiActiveInfoClass"
             (click)="clickOutsideWiki()">
            <div class="wiki-info color-light bg-wiki" data-testid="wiki-info">
                <div class="wiki-info__btn-close">
                    <img class="wiki-info__img bg-style cursor-pointer"
                         ngSrc="/assets/img/icons/cancel.svg"
                         data-testid="wiki-close-icon"
                         (click)="menu.showWiki(0)"
                         width="30" height="30" alt=""/>
                </div>
                <h2 class="wiki-info__title">{{ menu.wikiTitle }}</h2>
                <p class="wiki-info__desc font-15">{{ menu.wikiInfo }}</p>
            </div>
        </div>
    }

    <div class="input-password-wrapper"
         [ngStyle]="{ height: views.submenuWindowHeight}"
         *ngIf="menu.showInputField"
         [class]="{ 'input-password-wrapper--active': menu.showInputField && !menu.showDropdownMenu }">

        <div class="input-password bg-light">
            <div class="input-password__form">
                <div class="input-password__btn--close">
                    <img class="input-password__img bg-style cursor-pointer"
                         ngSrc="/assets/img/icons/cancel.svg"
                         (click)="menu.showInputPassword(-1)"
                         width="25" height="25" alt="" />
                </div>
                <input class="input-password__input border-input"
                       type="password"
                       autocomplete="new-password"
                       [(ngModel)]="menu.password"
                       placeholder="{{subtitle(1219)}}"
                       required />
                <br>
                <button class="input-password__submit bg-style color-light cursor-pointer  font-bold font-16"
                    (click)="menu.usePassword()">
                        {{subtitle(menu.passwordElement.txtId)}}
                </button>
            </div>
        </div>
    </div>
</div>
